import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";

export const Cash = () => {
    document.title = "Kassa";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <h2 className="my-4">Kassa</h2>
                <div className="row g-4">
                    <div className="col-6">
                        <Link to={"program"}>Kassa proqramı</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"login"}>Giriş</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"sale"}>Satış</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"return"}>Qaytarma</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"turn"}>Növbələr</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"payments"}>Mədaxil & Məxaric</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"handpanel"}>Əl paneli</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"settings"}>Ayarlar</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"rightpanel"}>Sağ panel</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"customer"}>Müştəri</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"discount"}>Endirim</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"paymenttypes"}>Ödəniş növləri</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"queue"}>Gözləmə</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"credit"}>Nisyə</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"party"}>Partiya</Link>
                    </div>
                    <div className="col-6">
                        <Link to={"units"}>Ölçü vahidləri</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
